import { Injectable, inject } from '@angular/core';
import type { SafeHtml } from '@angular/platform-browser';

import { I18nService } from '@core/i18n-legacy';

import { TERMS_URL } from './constants';
import { UrlInTranslationsPipe } from '../pipes/url-in-translations.pipe';

@Injectable({ providedIn: 'root' })
export class AdpHelpers {
  protected readonly i18n = inject(I18nService);
  protected readonly urlInTranslationsPipe = inject(UrlInTranslationsPipe);

  public claimsHeading(): SafeHtml {
    return this.urlInTranslationsPipe.transform(
      this.i18n.translate('rti.adp.settings.legal_dialog.special_terms_heading'),
      { a: 'target=_blank href=' + TERMS_URL },
    );
  }

  public claims(): SafeHtml[] {
    return [...Array(13).keys()].map(n =>
      this.i18n.translate(`rti.adp.settings.legal_dialog.special_terms.${n + 1}`),
    );
  }
}
